<template>
  <div>
    <v-list flat>
      <pc-client-side-navigation-item
        id="riaAdvisorFirmsClientNavigationItem"
        icon="pc-entity-account"
        title="Advisory firms"
        :selected="activeItem == 'riaAdvisoryFirms'"
        :to="'/accounts/' + $store.state.masterAccount?.id"
        :no-tooltips="sideMenuIsExpanded"
        data-id="15ef8de91ca01b13a8817ca76a6899d1"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        id="riaEmailTemplatesClientNavigationItem"
        icon="pc-email"
        :icon-size="13"
        title="Advisor email templates"
        :selected="activeItem == 'advisorEmailTemplates'"
        :to="
          '/accounts/' +
          $store.state.masterAccount?.id +
          '/advisor-email-templates'
        "
        :no-tooltips="sideMenuIsExpanded"
        data-id="b403d15cd124fc0cb3e5a941130d8cba"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        v-if="riaFeeScheduleFeatureEnabled"
        id="riaFeeSchedulesClientNavigationItem"
        icon="pc-entity-ria-fee-schedule"
        :icon-size="13"
        title="RIA fee schedules"
        :selected="activeItem == 'riaFeeSchedule'"
        :to="
          '/accounts/' + $store.state.masterAccount?.id + '/ria-fee-schedules'
        "
        :no-tooltips="sideMenuIsExpanded"
        data-id="b403d15cd124fc0cb3e5a941130d8cba"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        id="riaUserAgreementsClientNavigationItem"
        icon="pc-legal"
        :icon-size="13"
        title="User agreements"
        :selected="activeItem == 'userAgreements'"
        :to="'/accounts/' + $store.state.masterAccount?.id + '/user-agreements'"
        :no-tooltips="sideMenuIsExpanded"
        data-id="d4b5822a8a453759a1f14d011dbf9780"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        v-if="!$store.getters.hasContextTabs"
        id="riaReportsClientNavigationItem"
        icon="pc-workflow-taxes-department"
        :icon-size="13"
        title="Reports"
        :selected="activeItem == 'riaReports'"
        :to="'/accounts/' + $store.state.masterAccount?.id + '/ria-reports'"
        :no-tooltips="sideMenuIsExpanded"
        data-id="4f51662d322dd655af828115b3a5c0e2"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        id="riaAccountClientNavigationItem"
        icon="pc-settings"
        title="Account details"
        :selected="activeItem == 'riaAccount'"
        :to="'/accounts/' + $store.state.masterAccount?.id + '/ria-account'"
        :no-tooltips="sideMenuIsExpanded"
        data-id="6b04a34039ec773eef2b4a7ff3336db7"
      ></pc-client-side-navigation-item>

      <pc-advisor-user-settings-navigation-item
        v-if="!$store.getters.hasContextTabs"
        :active-item="activeItem"
        :side-menu-is-expanded="sideMenuIsExpanded"
      ></pc-advisor-user-settings-navigation-item>
    </v-list>
  </div>
</template>

<script>
import Account from "@/shared/lib/client-sdk/models/account";
import PcClientSideNavigationItem from "@/client/components/layout/PcClientSideNavigationItem";
import getFeatureFlag from "@/shared/lib/getFeatureFlag";
import PcAdvisorUserSettingsNavigationItem from "@/advisor/components/layout/PcAdvisorUserSettingsNavigationItem";

export default {
  components: {
    Account,
    PcClientSideNavigationItem,
    PcAdvisorUserSettingsNavigationItem,
  },

  props: {
    activeAccount: {
      type: Account,
      required: false,
    },
    activeItem: {
      type: String,
      required: false,
      default: "",
    },
    sideMenuIsExpanded: {
      type: Boolean,
      required: false,
      default: "",
    },
    isRiaFeeScheduleFeatureEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      riaFeeScheduleFeatureEnabled: false,
    };
  },

  async created() {
    this.riaFeeScheduleFeatureEnabled = await getFeatureFlag(
      "nextLevelRiaFeeScheduleUpload"
    );
  },
};
</script>

<style lang="scss"></style>
